import { Component, OnInit } from '@angular/core';
import { AppConstants } from 'src/app/app.constants';
import { BaseComponent } from 'src/app/layout/main/base.component';

@Component({
  selector: 'app-invalid',
  templateUrl: './invalid.component.html',
  styleUrls: ['./invalid.component.scss']
})
export class InvalidComponent extends BaseComponent implements OnInit {

  ngOnInit() {
    this.baseTriggerChild.subscribe(event => {
      this.app.spinner.hide();
    });
    this.start();
  }

  gotoHome() {
    this.app.router.navigate([AppConstants.RouteSelectConsultation]);
  }
}
